import Commerce from "@chec/commerce.js";

export const commerce = new Commerce(
  "pk_32044049e75767db5c7a63ed370418948ab99c4e70425",
  true
);

// faltu pk_test_19661763baf3194382812193e2e539617b1870f41d8b9

//manav  "pk_32044049e75767db5c7a63ed370418948ab99c4e70425",
